export default __webpack_public_path__ + "static/2020_2021_WVS INDIA CONSOLIDATED ACCOUNTS-34f1b1b77ac4cbeb1ada0f2334beccc4.pdf";